export default __webpack_public_path__ + "static/media/background_print_gjm.12cf1cc1.png";